export default __webpack_public_path__ + "static/media/agnidus_agate_sliver.ebc11490.png";